/**
 * Pure helpers for Bulk Export Full Counts UI (testable without React).
 */

export const MANAGER_LOAD_ERROR_MESSAGE =
  'Area Managers could not be loaded. Please refresh and try again.';

export async function loadBulkExportManagers({
  request,
  isCancelled = () => false,
  setLoading,
  setManagers,
  setError
}) {
  setLoading(true);
  setError('');
  try {
    const response = await request(
      '/api/tenant/reports/full-inventory/bulk-export/managers',
      { timeout: 30000 }
    );
    if (!isCancelled()) {
      setManagers(Array.isArray(response?.data?.managers) ? response.data.managers : []);
    }
  } catch (_) {
    if (!isCancelled()) {
      setManagers([]);
      setError(MANAGER_LOAD_ERROR_MESSAGE);
    }
  } finally {
    if (!isCancelled()) setLoading(false);
  }
}

export function buildBulkExportSitesParams(selectedManagerIds, startDate, endDate) {
  const params = { managerIds: (selectedManagerIds || []).join(',') };
  if (startDate && endDate) {
    params.startDate = startDate;
    params.endDate = endDate;
  }
  return params;
}

export function toggleIdInSelection(selectedIds, id) {
  const list = Array.isArray(selectedIds) ? selectedIds : [];
  if (list.includes(id)) return list.filter((x) => x !== id);
  return [...list, id];
}

export function selectAllAvailableSiteIds(sites) {
  return (sites || []).filter((s) => s && s.countAvailable).map((s) => s.siteId);
}

export function countSelectedAvailable(sites, selectedSiteIds) {
  const selected = new Set(selectedSiteIds || []);
  return (sites || []).filter((s) => s.countAvailable && selected.has(s.siteId)).length;
}

export function validateBulkExportDateRange(startDate, endDate) {
  if (!startDate || !endDate) return '';
  if (endDate < startDate) return 'End date must be the same as or later than the start date.';
  return '';
}
